/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import Character from '@assets/images/bg/character/betting-cancel.png'
import { CharacterDialog } from '@views/Popup/Dialog/CharacterDialog'
import { makeGodBlessItemAvailableFoldConditionInvalidDialogText } from '@utils/utils'
import * as _ from 'lodash'

export const GotBlessItemNotUsableInfo: React.FC = observer(() => {
  const img = <img src={Character} alt="캐릭터" className="guide-character"/>
  const title = (
    <p className="guide-txt big">
      신의 가호 사용이 <span className="point-color--orange--modal">불가능</span>합니다.
    </p>
  )

  const messages = makeGodBlessItemAvailableFoldConditionInvalidDialogText()
  const messagesLength = _.size(messages)
  const body = (
    <div className="guide-box small ">
      {
        _.map(messages, (message, index) => {
          if (index === messagesLength - 1) {
            return message
          }
          return <Fragment>{message}<br/><br/></Fragment>
        })
      }
    </div>
  )

  return (<CharacterDialog characterImg={img} title={title} body={body}/>)
})
